import { render, staticRenderFns } from "./AddWorkplacePage.vue?vue&type=template&id=0c485c97&"
import script from "./AddWorkplacePage.vue?vue&type=script&lang=js&"
export * from "./AddWorkplacePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports